import { render, staticRenderFns } from "./BUP0110.vue?vue&type=template&id=c5cf6320&scoped=true&"
import script from "./BUP0110.vue?vue&type=script&lang=js&"
export * from "./BUP0110.vue?vue&type=script&lang=js&"
import style0 from "./BUP0110.vue?vue&type=style&index=0&id=c5cf6320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5cf6320",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBadge,VBtn,VForm,VIcon,VTextField})
